import * as React from "react";

const SvgWorkbenchTabArrowRight = props => <svg viewBox="0 0 15 15" style={{
  enableBackground: "new 0 0 15 15"
}} xmlSpace="preserve" width="1em" height="1em" {...props}><path d="M7.5 0C3.4 0 0 3.4 0 7.5S3.4 15 7.5 15 15 11.6 15 7.5 11.6 0 7.5 0zm2.2 8-2.8 2.8c-.1.1-.3.2-.5.2s-.4 0-.6-.1c-.3-.3-.3-.8 0-1.1l2.3-2.3-2.3-2.3c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0L9.7 7c.3.3.3.7 0 1z" className="workbench_tab_arrow_right_svg__st0" /></svg>;

export default SvgWorkbenchTabArrowRight;